// extracted by mini-css-extract-plugin
export default {"tile":"Tiles_tile__uVwO0","spin":"Tiles_spin__+ATSE"};